// Making Instagram Feed Headings Into Links
(() => {
    const f1 = document.querySelector('#insta-feed');
    const f2 = document.querySelector('#feed-25167');
    if (!f1 || !f2) return;

    const f = (mutList) => {
        for (const mut of mutList) {
            if (mut.type !== 'childList' || mut.addedNodes.length !== 1 || mut.addedNodes[0].nodeName !== 'H2') {
                continue;
            }

            const el = mut.addedNodes[0];
            if (!el || el && !el.innerHTML) continue;
            const ih = el.innerHTML;
            el.innerHTML = `<a href="https://www.instagram.com/${ih.replace('@', '')}" target="_blank" rel="nofollow">${ih}</a>`;
        }
    };

    const obs = new MutationObserver(f);
    const cfg = { attributes: false, childList: true, subtree: true };
    obs.observe(f1, cfg);
    obs.observe(f2, cfg);
})();

// Product page section styling
(() => {
    const els = document.querySelectorAll('.additional-product-info > div');
    if (els.length % 2 === 0) return;

    const bg = q => {
        const el = document.querySelector(q);
        if (!el) return;
        el.parentElement.classList.add('gray-background');
    }

    bg('#shopify-product-reviews');
    bg('#judgeme_product_reviews');
})();

// fix judge exception
(() => {
    const f = (q) => {
        const res = document.querySelector(q);
        if (res !== null) return;
        const el = document.createElement('div');
        el.classList.add(q);
        el.style.display = 'none';
        document.body.appendChild(el);
    }

    f('.jdgm-rev-widg');
    f('.jdgm-submit-rev');
})();

// Size chart switch to metric script
(() => {
	const units = document.querySelectorAll('.convert-size-chart .format .units');
	const metric = 'Switch To Metric';
	const standard = 'Switch To Standard';
	units.forEach((u) => {
		u.addEventListener('click', (e) => {
			e.preventDefault();

            units.forEach((el) => {
                el.innerText = u.innerText === metric ? standard : metric;
            });

			document.querySelectorAll('.convert-size-chart .tab-standard').forEach((el) => {
				el.classList.toggle('hide');
			});

			document.querySelectorAll(".convert-size-chart .tab-metric").forEach((el) => {
				el.classList.toggle('hide');
			});
		});
	});
})();

// Handle modals
document.addEventListener("DOMContentLoaded", () => {
    const modals = document.querySelectorAll('.modal-trigger');

    modals.forEach(el => {
        try {
            if (el.getAttribute('data-modal-init')) {
                return;
            }

            el.addEventListener('click', (e) => {
                e.stopImmediatePropagation();
                e.preventDefault();

                const target = document.querySelector(el.dataset.target);
                if (!target) return;

                target.classList.toggle('active');
                target.setAttribute('aria-hidden', !target.classList.contains('active'));

                if (target.getAttribute('data-modal-init')) {
                    return;
                }

                target.addEventListener('click', (e) => {
                    const href = e.target.getAttribute('href') || e.target.parentElement.getAttribute('href');
                    if ((e.target.tagName === 'A' || e.target.parentElement.tagName === 'A') && !!href && href !== '#') {
                        return;
                    }

                    e.stopImmediatePropagation();
                    e.preventDefault();
                    if (!e.target.classList.contains('modal')) return;

                    target.setAttribute('aria-hidden', true);
                    target.classList.remove('active');
                });

                target.setAttribute('data-modal-init', true);
                const close = target.querySelector('.close');
                if (!close) {
                    return;
                }

                close.addEventListener('click', (e) => {
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    target.setAttribute('aria-hidden', true);
                    target.classList.remove('active');
                });
            });

            el.setAttribute('data-modal-init', true);
        } catch (e) {
            console.error(e);
        }
    });

    document.addEventListener('keydown', (evnt) => {
        if (evnt.key !== 'Escape') {
            return;
        }

        const modals = document.querySelectorAll('.modal');
        modals.forEach(el => {
            el.classList.remove('active');
            el.setAttribute('aria-hidden', true);
        });
    });
});

// What Customers Are Saying
(() => {
    const el = document.querySelector('.comments .quotes');
    if (!el) {
        return;
    }

    const comments = [
        'I can always count on Cleanline Surf to supply us with the best girls wetsuit with great deals plus very helpful customer service. I highly recommend you to my family and friends.',
        'Seriously a great experience and product! From the prices to the personalized note. I just wanted to share why my family gets so excited to receive this wetsuit. My son has cold urticaria- which essential means he is allergic to cold. I know, crazy but research it, it is real! He will go into anaphylactic shock. He was diagnosed at 4 and is now 8. One of the hardest things we battled with was swimming in outdoor pools, indoor pools, lakes, oceans, or running through the sprinklers. With his wetsuit he feels like a super hero that can overcome! Thank you for making it a great experience to order from you. I hope I can find great prices & products each year so we can shop with you again!',
        'Just want to say thank you for being AMAZING. I ordered my first wetsuit from you and it shipped fast. I was shocked to see all the goodies and the handwritten thank you note along with the quality gear I ordered. Your stickers will be going on my truck soon and I have been telling all my friends about you guys. Shopping with you was a great experience and I will ll definitely be ordering some more suits from you in the very near future for the wife and kids!',
        'The crew at Cleanline Surf are always awesome. I have mostly purchased via their website. The gear gets shipped quickly which means it arrives just as fast. If they are low on stock, they will call the store that has it while I wait on hold to make sure it is actually there. Take the time to stop in or check them out online. They are my go-to surf shop on the Oregon Coast.',
        'I just wanted to let you know in reference to my order. I was so pleasantly surprised at the customer service. When the package arrived my wife opened it (It was a gift for our son for his birthday) and she opened it and said "Oh my gosh, it is a handwritten note and some candy" In this age of terrible customer service and everyone is just a number on Amazon, received a product so quickly and with all the personal touches that actually lets you know that a real person not a "robot" mailed a package, made us decide that if we ever need anything surf related again we will 100 percent order from you again. Not to mention that the package was wrapped so nicely so as not to cause damage. It was great and we were so impressed. I wish we lived in Oregon we would visit your shop. Great job and we look forward to ordering from you again!',
        'I am from Massachusetts and this is the only site I order from even though they are located across the county in Oregon. Their customer service is next to none. They take the time to respond to any email as if you are in the store yourself whether it is ding repair or wetsuit sizing. Also the personalized post cards and starburst in your package does not hurt.',
        'Thank you for all your help helping me choose my new wetsuit and getting it to me on time for a nice hurricane swell last Friday. I chose the O Neill Psycho Tech 3/2 and I love it. It felt snug trying it on at home, but once I surfed it, it was perfect. Super warm in 62 degree water, I know it will take cooler. Very flexible and light. Thanks for taking my several calls and answering my questions. Thanks Again',
        'Ok people... I have worked in the skate, surf, and snowboard industry for well over a decade and customer service even longer! I have never seen anything like this. I mean the shop looks like your average surf shop. But the people that work there are incredible! I have been coming into buy and rent for a few summers now. And they always remember me (I live in Boise Idaho!) so they see me very few and far between. This last time, I requested a specific board to rent in advance. When I got there they forgot to have it transferred down from the Sea Side shop. So what does the guy do... He drops everything he is doing and drives 30min to and from the other shop just to get me that specific board. And I did not mind the wait due to the skate park being like a mile away. When I got back, the board was ready and he gave me a discount on the entire deal. Smiles, hand shakes, and high fives all around! Spencer, you\'re the man!',
        'I just want to acknowledge the personal service I received with the arrival of my Visla wetsuit. Thank you all for the Starbursts sprinkled in my package, the surf wax, stickers, and the handwritten postcard. Thank you all so much, and Cleanline will be my go-to for ordering surf gear online (as I live down in Encinitas, CA).',
        'Not good, EXCELLENT! Loved the friendly tone of every email exchange! I was actually looking forward to them, hahahha. Thank you very much for the personalized attention.',
        'I ordered a new winter wetsuit and when my package arrived I felt like it was my birthday! The wetsuit came along with some freebies: a yummy smelling bar of coconut surf wax, a really nice surf shop t-shirt (perfect fit), some sweets, and a note. Super customer service! It\'s obvious they take pride in and enjoy their work. I wish I worked for them!',
        'I wanted to tell you how professional and AWESOME James customer service is. He\'s knowledgeable and cares about the customer needs.',
        'I always have such good communication with this business. They are so uniquely on top of it! Great follow up every time!',
        'The Michael Jordan of surf companies.',
        'Great, helpful, timely communication. Really appreciate supporting a longstanding OR surf shop and getting great customer service at the same time! Crushing it!',
        'From their easily navigated website, to their prompt shipping, to their personal note in my first purchase, dealing with Cleanline has been a pleasure. When I needed to return one of the items from my second purchase, they gave me clear instructions and the option of a UPS return voucher. Nice people and great service!',
        'Y\'all are always, and I mean always, amazing. Customer service is alive and well at your institution and my experience with Sarah just now, was no exception. Thank you, for helping me with product query and for treating me like a human bean!',
        'All support I received was excellent. You guys rock the customer service which will definitely make me buy again from you especially with four kids surfing in Michigan, wetsuits are a must!',
    ].sort(function() {return 0.5 - Math.random()});

    const renderRandomComment = () => {
        el.classList.add('fadein');
        comments.unshift(comments.pop());
        el.innerHTML = `<blockquote>${comments[0]}</blockquote>`;
        setTimeout(() => {
            el.classList.remove('fadein');
        }, 2e3); /* 2 seconds */
    };

    const timeout = 3e4; /* 30 seconds */
    let interval = setInterval(renderRandomComment, timeout);

    el.addEventListener('click', () => {
        clearInterval(interval);
        interval = setInterval(renderRandomComment, timeout);
        renderRandomComment();
    });

    renderRandomComment();
})();

// sale bar
(() => {
    const els = document.querySelectorAll('.cl-sale-bar');
    for (const el of els) {
        const ds = el.dataset;
        if (!ds) {
            continue;
        }

        const trm = s => (s || '').trim();
        const event = trm(ds.event);
        if (event) {
            el.addEventListener('click', el => {
                if (typeof gtag !== 'function') {
                    return;
                }

                gtag('event', 'click', {
                    'event_category': 'sale_bar',
                    'event_label': event,
                });
            });
        }

        const link = trm(ds.link);
        const popup = trm(ds.popup) === 'true';
        if (link && !popup) {
            el.addEventListener('click', el => {
                window.location.href = link;
            });
        }

        const countdown = trm(ds.countdown);
        if (countdown !== 'true') {
            continue;
        }

        const end = trm(ds.end);
        // countdown timer
        (() => {
            const ts = new Date(end * 1000);
            console.log(`countdown timer`, end, ts);

            if (Date.now() > ts){
                // over
                const title = el.querySelector('.countdown .title');
                if (title) {
                    title.textContent = 'Countdown Expired';
                }
                setTimeout(() => {
                    el.classList.add('fade-out');
                    setTimeout(() => {
                        el.classList.add('hide');
                    }, 700);
                }, 5000);
                return;
            }

            const cnt = el.querySelector('.inner');

            const switchDigit = (position, number) => {
                const digit = position.querySelector('.digit');

                if (position.dataset.digit == number) {
                    return false;
                }

                position.dataset.digit = number;

                replacement = document.createElement('span');
                replacement.classList.add('digit');
                replacement.innerHTML = number;

                digit.before(replacement);
                replacement.classList.add('slide-up');
                setTimeout(() => {
                    digit.remove();
                }, 100);
            };

            const updateDuo = (minor, major, value) => {
                const positions = el.querySelectorAll('.position');
                if (positions[minor]) {
                    switchDigit(positions[minor], Math.floor(value / 10) % 10);
                }

                if (positions[major]) {
                    switchDigit(positions[major], value % 10);
                }
            }

            const init = () => {
                // create & render clock elements
                cnt.classList.add('countdownHolder');

                const frag = document.createDocumentFragment();
                const createSpan = (text, ...classes) => {
                    const s = document.createElement('span');
                    s.classList.add(...classes);
                    if (text !== undefined && text !== '') {
                        s.textContent = text;
                    }
                    return s;
                };

                ['Days','Hours','Minutes','Seconds'].forEach((v,k) => {
                    const s = createSpan('', `count${v}`);
                    const s1 = createSpan('', 'position');
                    s1.appendChild(createSpan('0', 'digit', 'static'))
                    s.appendChild(s1);
                    const s2 = createSpan('', 'position')
                    s2.appendChild(createSpan('0', 'digit', 'static'));
                    s.appendChild(s2);
                    frag.append(s);

                    if (v !== 'Seconds') {
                        frag.append(createSpan(':', 'countDiv', `countDiv${k}`));
                    }
                });

                cnt.appendChild(frag);

                // setup timer
                const tick = () =>{
                    const days = 24 * 60 * 60;
                    const hours = 60 * 60;
                    const minutes = 60;

                    const nts = Math.floor( (ts - (new Date()) ) / 1000);
                    let left = nts > 0 ? nts : 0;
                    if (left === 0) {
                        el.classList.add('hide');
                    }

                    const d = Math.floor(left / days);
                    updateDuo(0, 1, d);
                    left -= d * days;
                    const h = Math.floor(left / hours);
                    updateDuo(2, 3, h);
                    left -= h * hours;
                    const m = Math.floor(left / minutes);
                    updateDuo(4, 5, m);
                    left -= m * minutes;
                    const s = left;
                    updateDuo(6, 7, s);
                }

                tick();
                window.clSaleBar = setInterval(tick, 1000);
            };

            init();
        })();
    }
})();

// manual delivery comformation error message
(() => {
    const button = document.querySelector('div[data-has-delivery-time="true"] .product-form__controls-group button[type="submit"]');
    if (!button) return;

    button.addEventListener('click', (e) => {
        const input = document.querySelector('body .product-single__meta .swatch.conformation input');
        if (!input) return;

        if (!input.checked) {
            e.preventDefault();
        }

        const tt = document.querySelector('body .product-single__meta .swatch.conformation .tooltip');
        tt.classList.add('required');
        tt.scrollIntoView({ behavior: 'smooth', block: 'center' });

        input.addEventListener('click', (e) => {
            if (!e.target.checked) {
                return;
            }

            tt.classList.remove('required');
            tt.classList.add('hide');
        });
    });
})();

(() => {
    const debounce = (f, delay) => {
        let timer = 0;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => f.apply(this, args), delay);
        }
    };

    const chunk = (arr, len) => {
        const a = [...arr];
        return Array(Math.ceil(a.length / len))
            .fill()
            .map((_, i) => i * len)
            .map(i => a.slice(i, i + len));
    };

    document.addEventListener("DOMContentLoaded", () => {
        const parent = document.querySelector('body.boost-pfs-enable-app .boost-pfs-filter-products');
        if (!parent) return;

        const handleEntry  = (entry) => {
            const children = entry.target.children;
            if (!children) return;

            const perRow = window.innerWidth <= 767 ? 2 : 3;
            const rows = chunk(children, perRow);
            let index = 0;
            for (const row of rows) {
                index++;
                handleRow(row, index);
            }
        };

        const handleRow = (row, index) => {
            if (row.some(child => child.classList.contains('boost-pfs-filter-product-skeleton'))) {
                return;
            }

            const rowHasSwatches = row.some(child => child.querySelectorAll('.boost-pfs-filter-item-swatch li').length >= 1);
            const rowHasOnlyHiddenSwatches = row.every(child => child.querySelectorAll('.boost-pfs-filter-item-swatch li').length <= 1);

            for (const child of row) {
                child.classList.remove('item-has-swatch', 'item-has-swatches', 'item-has-no-swatches', 'row-has-swatches', 'row-has-only-hidden-swatches');
                child.dataset.rowIndex = index;
                child.classList.add(`row-${index}`);

                const reviews = child.querySelector('.jdgm-prev-badge')?.getAttribute('data-number-of-reviews');
                if (reviews > 0) {
                    child.classList.add('item-has-reviews');
                }

                const len = child.querySelectorAll('.boost-pfs-filter-item-swatch li').length;
                if (len > 1) {
                    child.classList.add('item-has-swatches', 'row-has-swatches');
                    continue;
                }

                if (rowHasSwatches) {
                    child.classList.add('row-has-swatches');
                }

                if (rowHasOnlyHiddenSwatches) {
                    child.classList.add('row-has-only-hidden-swatches');
                }

                if (len === 1) {
                    child.classList.add('item-has-swatch');
                    continue;
                }

                child.classList.add('item-has-no-swatches');
            }
        };

        const resizeObserver = new ResizeObserver(debounce((entries) => {
            for (const entry of entries) {
                handleEntry(entry);
            }
        }, 100));

        resizeObserver.observe(parent);
    });
})();

((window) => {
    const isDaylightSavingTime = () => {
        const d = new Date();
        const jan = new Date(d.getFullYear(), 0, 1).getTimezoneOffset();
        const jul = new Date(d.getFullYear(), 6, 1).getTimezoneOffset();
        return Math.max(jan, jul) !== d.getTimezoneOffset();
    }

    const countdown = (el, end = '', overMsg = 'Countdown Expired') => {
        if (!el) {
            console.log('could not find countdown timer html element', el);
            return;
        }

        if (end === 0) {
            console.log('invalid countdown timer end time', el);
            return;
        }

        const dateString = `${end}-0${isDaylightSavingTime() ? '7' : '8'}:00`;
        const ts = Date.parse(dateString);
        if (!Number.isFinite(ts)) {
            console.log(`invalid countdown timer end time parsed from ${dateString}`, el);
            return;
        }

        // const ts = new Date(end * 1000);
        if (Date.now() > ts){
            // over
            const title = el.querySelector('.title');
            if (title) {
                title.textContent = overMsg;
            }

            setTimeout(() => {
                el.classList.add('fade-out');

                setTimeout(() => {
                    el.classList.add('hide');
                }, 700);
            }, 5000);

            return;
        }

        const cnt = el.querySelector('.inner');

        const switchDigit = (position, number) => {
            const digit = position.querySelector('.digit');

            if (position.dataset.digit == number) {
                return false;
            }

            position.dataset.digit = number;

            replacement = document.createElement('span');
            replacement.classList.add('digit');
            replacement.innerHTML = number;

            digit.before(replacement);
            replacement.classList.add('slide-up');
            setTimeout(() => {
                digit.remove();
            }, 100);
        };

        const updateDuo = (minor, major, value) => {
            const positions = el.querySelectorAll('.position');
            if (positions[minor]) {
                switchDigit(positions[minor], Math.floor(value / 10) % 10);
            }

            if (positions[major]) {
                switchDigit(positions[major], value % 10);
            }
        }

        // create & render clock elements
        cnt.classList.add('countdownHolder');

        const frag = document.createDocumentFragment();
        const createSpan = (text, ...classes) => {
            const s = document.createElement('span');
            s.classList.add(...classes);
            if (text !== undefined && text !== '') {
                s.textContent = text;
            }
            return s;
        };

        ['Days','Hours','Minutes','Seconds'].forEach((v,k) => {
            const s = createSpan('', `count${v}`);
            const s1 = createSpan('', 'position');
            s1.appendChild(createSpan('0', 'digit', 'static'))
            s.appendChild(s1);
            const s2 = createSpan('', 'position')
            s2.appendChild(createSpan('0', 'digit', 'static'));
            s.appendChild(s2);
            frag.append(s);

            if (v !== 'Seconds') {
                frag.append(createSpan(':', 'countDiv', `countDiv${k}`));
            }
        });

        cnt.appendChild(frag);

        // setup timer
        const tick = () =>{
            const days = 24 * 60 * 60;
            const hours = 60 * 60;
            const minutes = 60;

            const nts = Math.floor( (ts - (new Date()) ) / 1000);
            let left = nts > 0 ? nts : 0;
            if (left === 0) {
                el.classList.add('hide');
            }

            const d = Math.floor(left / days);
            updateDuo(0, 1, d);
            left -= d * days;
            const h = Math.floor(left / hours);
            updateDuo(2, 3, h);
            left -= h * hours;
            const m = Math.floor(left / minutes);
            updateDuo(4, 5, m);
            left -= m * minutes;
            const s = left;
            updateDuo(6, 7, s);
        }

        tick();
        if (!window.clCountdown) {
            window.clCountdown = [];
        }

        window.clCountdown.push(setInterval(tick, 1000));
    };

    const els = document.querySelectorAll('.cl-countdown');
    if (els.length === 0) return;

    for (const el of els) {
        if (!el.dataset.end) {
            continue;
        }

        countdown(el, el.dataset.end, el.dataset.overMsg);
    }
})(window);